// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd954327","455":"2df468ee","488":"edda780f"}[chunkId] + ".chunk.js";
};